import { ISymbolInfo } from "@/services/trade/symbols";

type OperationType = "Buy" | "Sell";

interface GetInitialValuesProps {
    symbolId?: string;
    lotSize?: string | number;
    operationType?: OperationType;
}

type SymbolsInfoById = Record<string, ISymbolInfo>;

interface GetInitialValuesResult {
    symbolId: string;
    symbolInfo: ISymbolInfo;
    lotSize: string | number;
    operationType: OperationType;
}

export function getInitialValues(
    props: GetInitialValuesProps,
    activeSymbolId: string,
    symbolsInfoById: SymbolsInfoById
): GetInitialValuesResult {
    let { symbolId, lotSize = 0.01, operationType = "Buy" } = props;
    symbolId = symbolId || activeSymbolId;

    const symbolInfo = symbolsInfoById[symbolId];
    const lotMin = symbolInfo?.group?.lotMin || 0.01;
    const lotMax = symbolInfo?.group?.lotMax || 100;

    lotSize = +lotSize > lotMax ? lotMin : lotSize;

    return { symbolId, symbolInfo, lotSize, operationType };
}